export enum SearchDisplayMode {
    NONE = 'NONE',
    PREVIEW = 'PREVIEW',
    FORM = 'FORM',
}

export type SearchPreviewTarget = 'NONE' | 'JOB' | 'LOCATION';
